import VendorCampaignsAdminPartial from "../../../partials/admin/vendors/vendor-campaigns.admin.partial";

export default function VendorCampaignsAdminScreen() {
  return <VendorCampaignsAdminPartial />;
}
